export function removeUUIDs(pathname: string, removeAll: boolean) {
  const REGEX_FIRST_UUID =
    /\/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/;
  const REGEX_ALL_UUIDs = new RegExp(REGEX_FIRST_UUID.source, 'g');
  return pathname?.replace(removeAll ? REGEX_ALL_UUIDs : REGEX_FIRST_UUID, '');
}
